import { SelectProps } from '@amzn/awsui-components-core';
import { TaskSkill } from '@amzn/awscat-pattern-library-service-model';
import constants from '../../common/constants';
import { taskSkillDisplayNames } from '../utils/DisplayNames';

export const getTaskSkills = (selectValues: string[], custValues: string) => {
  const availValues = selectValues.filter((i) => i && i !== TaskSkill.Other);
  const custValuesArr = custValues
    .split(',')
    .filter((i) => i !== '')
    .map((i) => i.trim());
  let skills = availValues.length > 0 ? availValues.join(',') : '';
  if (custValuesArr && custValuesArr.length > 0) {
    skills += (skills ? ',' : '') + custValuesArr.join(',');
  }
  return skills;
};

export const orderSkillOptions = (skillOptions: SelectProps.Option[]) => {
  const otherSkill = skillOptions.find((skill) => skill.value === TaskSkill.Other);
  const orderedSkillOptions = skillOptions.filter((skill) => skill.value !== TaskSkill.Other);
  if (otherSkill) {
    orderedSkillOptions.push(otherSkill);
  }
  return orderedSkillOptions;
};

export const validateSkills = (skills: string) => {
  let error: string = '';
  const valueArr = skills.split(',') || [];
  const duplicates = valueArr.filter((val, ind) => val != null && valueArr.indexOf(val) !== ind);
  if (duplicates.length > 0) {
    error = constants.TASK_SKILLS_DUPLICATE_SKILL;
  }
  return error;
};

export const getSkillLabels = (skills: string) => {
  return skills
    .split(',')
    .map((skill) => getItemLabel(skill))
    .join(', ');
};

const getItemLabel = (id: string) => {
  // @ts-expect-error TS7053 - strict migration
  const item = TaskSkill[id];
  return item ? taskSkillDisplayNames.get(item) : id;
};
